import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IDdlField,
  IField,
  IKey,
  IPageRequest,
  IPageResponse,
  ISort,
  // IStartupConfig,
  IResCallStack,
} from "../../app/types";

export interface IClient {
  user: string;
  pageReq: IPageRequest;
  pageResp: IPageResponse;
  respCallStack: IResCallStack[];
  frameLoad: boolean;
  ddlist: string[];
  ddlFetchFail: string[];
  ddlData: {};
  awaitResponse: boolean;
  // startupConfigs: IStartupConfig;
  maxChunkSize: number;
  editorDataBuffer: {};
  sorting: ISort;
}

let initialState: IClient = {
  user: "",

  pageReq: {} as IPageRequest,

  pageResp: {
    global: {
      screen: "RW7000",
    },
  } as IPageResponse,
  respCallStack: [],
  frameLoad: false,
  ddlist: [],
  ddlFetchFail: [],
  ddlData: {},
  awaitResponse: false,
  // startupConfigs: {} as IStartupConfig,
  maxChunkSize: 8000,
  editorDataBuffer: {},
  sorting: { order: "*SORTA", orderBy: "" },
};

const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    resetClientState: () => initialState,
    setUser(state, action: PayloadAction<string>) {
      state.user = action.payload;
    },
    setPageReqGlobalFunc(state, action: PayloadAction<string>) {
      state.pageReq.global.function = action.payload;
    },
    setPageReqGlobalGetOptions(state, action: PayloadAction<string>) {
      state.pageReq.global.getOptions = action.payload;
    },
    setPageReqGlobalAction(state, action: PayloadAction<string>) {
      state.pageReq.global.action = action.payload;
    },
    setPageReqGlobalReqCode(state, action: PayloadAction<string>) {
      state.pageReq.global.requestCode = action.payload;
    },
    setPageReqGlobalThread(state, action: PayloadAction<string>) {
      state.pageReq.global.thread = action.payload;
    },
    setPageReqGlobalScreen(state, action: PayloadAction<string>) {
      state.pageReq.global.screen = action.payload;
    },
    setPageReqGlobalFields(state, action: PayloadAction<string>) {
      state.pageReq.global.fields = action.payload;
    },
    setPageReqGlobalKeys(state, action: PayloadAction<string>) {
      state.pageReq.global.keys = action.payload;
    },
    setPageReqGlobalDdlists(state, action: PayloadAction<string>) {
      state.pageReq.global.ddlists = action.payload;
    },
    setPageReqKeys(state, action: PayloadAction<IKey[]>) {
      state.pageReq.keys = action.payload;
    },
    setPageReqDdlists(state, action: PayloadAction<IDdlField[]>) {
      state.pageReq.ddlists = action.payload;
    },
    setPageReqGlobalCaller(state, action: PayloadAction<string>) {
      state.pageReq.global.caller = action.payload;
    },
    setPageReqFields(state, action: PayloadAction<IField[]>) {
      state.pageReq.fields = action.payload;
    },
    setPageReq(state, action: PayloadAction<IPageRequest>) {
      state.pageReq = action.payload;
    },
    resetPageReq(state, action: PayloadAction<IPageRequest>) {
      state.pageReq = action.payload;
    },
    setPageResp(state, action: PayloadAction<IPageResponse>) {
      state.pageResp = action.payload;
    },
    setRespCallStack(state, action: PayloadAction<IResCallStack[]>) {
      state.respCallStack = action.payload;
    },
    setPageRespFields(state, action: PayloadAction<IField[]>) {
      state.pageResp.fields = action.payload;
    },
    setFrameLoad(state, action: PayloadAction<boolean>) {
      state.frameLoad = action.payload;
    },
    setDdlist(state, action: PayloadAction<string[]>) {
      state.ddlist = action.payload;
    },
    setDdlFetchFail(state, action: PayloadAction<string[]>) {
      state.ddlFetchFail = action.payload;
    },
    setDdlData(state, action: PayloadAction<{}>) {
      state.ddlData = action.payload;
    },
    setAwaitResponse(state, action: PayloadAction<boolean>) {
      state.awaitResponse = action.payload;
    },
    // setStartupConfigs(state, action: PayloadAction<IStartupConfig>) {
    //   state.startupConfigs = action.payload;
    // },
    setMaxChunkSize(state, action: PayloadAction<number>) {
      state.maxChunkSize = action.payload;
    },
    setEditorDataBuffer(state, action: PayloadAction<{}>) {
      state.editorDataBuffer = action.payload;
    },
    setSorting(state, action: PayloadAction<ISort>) {
      state.sorting = action.payload;
    },
  },
});

export const {
  resetClientState,
  setUser,
  setPageReq,
  resetPageReq,
  setRespCallStack,
  setPageReqGlobalFunc,
  setPageReqGlobalKeys,
  setPageReqGlobalDdlists,
  setPageReqKeys,
  setPageReqDdlists,
  setPageReqGlobalCaller,
  setPageReqGlobalGetOptions,
  setPageReqGlobalAction,
  setPageReqGlobalReqCode,
  setPageReqGlobalThread,
  setPageReqGlobalScreen,
  setPageReqGlobalFields,
  setPageReqFields,
  setPageResp,
  setPageRespFields,
  setFrameLoad,
  setDdlist,
  setDdlFetchFail,
  setDdlData,
  setAwaitResponse,
  // setStartupConfigs,
  setMaxChunkSize,
  setEditorDataBuffer,
  setSorting,
} = clientSlice.actions;

export default clientSlice.reducer;
